import { render, staticRenderFns } from "./menu-two-to-four-option-half-screen.vue?vue&type=template&id=09a21768&scoped=true&"
import script from "./menu-two-to-four-option-half-screen.vue?vue&type=script&lang=js&"
export * from "./menu-two-to-four-option-half-screen.vue?vue&type=script&lang=js&"
import style0 from "./menu-two-to-four-option-half-screen.vue?vue&type=style&index=0&id=09a21768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../WebVR/webvr-infest/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a21768",
  null
  
)

export default component.exports